import clsx from "clsx"

export default function Title({ title, subtitle, linkableID, className }) {
  return (
    <div className={clsx("px-6 pb-12 sm:pb-24 lg:px-8 mx-auto max-w-2xl text-center", className)}> 
        <h2
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl"
          id={linkableID}
        >
          {title}
        </h2>
        {subtitle && (
          <p className="mt-6 text-sm lg:text-lg leading-8 text-gray-600">{subtitle}</p>
        )} 
    </div>
  );
}
